export const TIMELINE_BLOCKS_CONSTANTS = {
  WIDTH: {
    PER_CLOSED_BLOCK: 25,
    PER_MILESTONE: 120,
    MARGIN_PER_BLOCK: 7,
    MIN_MAX_WIDTH: 170,
    DEFAULT_CONTAINER_WIDTH: 1191,
    SCROLL_SLIDE: 86,
  },

  DEFAULTS: {
    DROPDOWN: ['view All'],
    TOOLTIP_CHAR_WIDTH: 16,
    TOOLTIP_PADDING: 32,
    INITIAL_TIMELINE_TOTAL: 0,
  },

  COLORS: {
    CAMPAIGN: '#000000',
    PRODUCT: '#1E43A1',
    MAGELLAN: '#1E43A1',
    'COLLECTOR / PRODUCT': '#086289',
    GIFT: '#923065',
    SET: '#502B9D',
  },

  GATE_MILESTONE_NAMES: [
    'GO 360 KICK OFF',
    'GO 360 STRATEGIC NOTE',
    'GO KEY VISUALS',
    'GO PRIORITY PAID MEDIA ASSETS',
    'GO E-RETAIL PDP ASSETS',
    'GO BRIEF MAGELLAN',
    'MARKETING BOOK',
  ],

  ROUTES: {
    TIMELINE_SETTING: ['workspaces/campaigndrive', 'timeline-setting'],
    DASHBOARD: ['/workspaces/campaigndrive/dashboard'],
    MATCH_PATHS: [
      '/workspaces/campaigndrive/5806860095/dashboard/task-project',
      '/workspaces/campaigndrive/0688832012/dashboard/task-project',
      '/workspaces/campaigndrive/0143110813/dashboard/task-project',
    ],
  },

  UI: {
    MODAL: {
      SIZE: 'lg',
      CLASS: 'responsive-modal',
    },
    STATUS_COLORS: {
      DEFAULT: '#fff',
    },
    OPACITY: {
      FULL: 1,
      DIM: 0.3,
    },
  },
};
